<script>
    import {
        assets,
        handleAssetsDelete,
        handleScopeChange,
        handleAutoDeleteChange,
        hydrateAssetsWithTags,
        replaceAssetsListElements,
        searchAssets,
    } from "../assets.state.svelte.js";
    import { PowerTable } from "@muonw/powertable";
    import { onMount, tick, onDestroy } from "svelte";
    import AssetsApi from "../assets.api.js";
    import { is_hostname_list, is_ip_list } from "../assets.api.js";
    import powerTableService from "../../../services/powerTable.js";
    import Form from "../_form_kind.svelte";
    import MassiveEditForm from "../_form_massive_edit.svelte";
    import MassiveActionsService from "../../../services/massive-actions.js";
    import MassiveAddForm from "../_form_massive_add.svelte";
    import TagForm from "../../tag/_form.svelte";
    import RemoveAssetTag from "./remove-asset-tag.svelte";
    import {
        ipAdressesCustomComparator,
        normalizeString,
        isJson,
        dateText,
    } from "../../../js/utils.js";
    import countries from "../../../services/countries.js";
    import OpenPortsRow from "../../../components/powerTable/open-ports-row.svelte";
    import { notificate } from "../../../services/notification.js";
    import { locale, format } from "svelte-i18n";
    import { user } from "../../user/user.state.svelte.js";
    import dayjs from "dayjs";
    import relativeTime from "dayjs/plugin/relativeTime";
    import localizedFormat from "dayjs/plugin/localizedFormat";
    import TableReference from "../../../components/table-reference.svelte";
    import { params } from "@roxi/routify";
    import * as bootstrap from "bootstrap";
    import "dayjs/locale/es";
    import "dayjs/locale/en";

    $params;

    dayjs.locale($locale);
    dayjs.extend(relativeTime);
    dayjs.extend(localizedFormat);

    let { kind, tags = [], associations = [], showActions = true } = $props();

    // --- SECURITY: XSS Sanitizer ---
    const escapeHTML = (str) => {
        if (!str && str !== 0) return "";
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    };

    const orderByFindingsAndScope = (data) => {
        if (data)
            data =
                kind && kind != "all" && kind != "allWithActions"
                    ? data.filter((elem) => elem.kind == kind)
                    : data;
        return [...data].sort((v1, v2) => {
            if (v1.finding_count && v2.finding_count) {
                const c1 =
                    v1.finding_count.critical.open +
                    v1.finding_count.critical.accepted;
                const c2 =
                    v2.finding_count.critical.open +
                    v2.finding_count.critical.accepted;

                if (c1 !== c2) return c2 - c1;

                const h1 =
                    v1.finding_count.high.open + v1.finding_count.high.accepted;
                const h2 =
                    v2.finding_count.high.open + v2.finding_count.high.accepted;

                if (h1 !== h2) return h2 - h1;

                const m1 =
                    v1.finding_count.medium.open +
                    v1.finding_count.medium.accepted;
                const m2 =
                    v2.finding_count.medium.open +
                    v2.finding_count.medium.accepted;

                if (m1 !== m2) return m2 - m1;

                const l1 =
                    v1.finding_count.low.open + v1.finding_count.low.accepted;
                const l2 =
                    v2.finding_count.low.open + v2.finding_count.low.accepted;

                if (l1 !== l2) return l2 - l1;
            }

            if (!v1.in_scope && v2.in_scope) return 1;
            if (!v2.in_scope && v1.in_scope) return -1;

            return 0;
        });
    };

    let data = $derived.by(() => {
        return orderByFindingsAndScope(assets.list.data);
    });

    let listData = $derived(data);
    let out_of_scope_length = $derived(
        data.filter((item) => !item.in_scope).length,
    );

    let selected_rows = $state([]);
    let tableElement = $state();
    let ptInstructs = $state([]);
    let checkbox;
    let table_is_expanded = $state(false);
    let show_expand_button = true;
    let searchInput = $state("");

    // Form Keys for pristine resets
    let addFormKey = $state(0);
    let editFormKey = $state(0);

    // Bootstrap Modal Instances & Elements
    let addModalElement;
    let addModalInstance;
    let editModalElement;
    let editModalInstance;
    let ShowMassiveAdditionForm = $state(false);

    tags = tags.sort((a, b) => a.name.localeCompare(b.name));

    /* START LIST FUNCTIONS */

    const getAssetsColumnsDefinition = (kind) => {
        if (!kind) return;
        let cols = [];
        let extraCols = {
            properties: [],
            relations: [],
            relatedAssetsKind: [],
        };

        if (kind != "all") {
            cols.push({
                key: "select",
                title: "",
                filterable: false,
                sortable: false,
            });
        }

        cols.push(
            {
                key: "name",
                title: $format("list.columns.name"),
                filterable: false,
                parseAs: "unsafe-html",
            },
            {
                key: "description",
                title: $format("list.columns.description"),
                parseAs: "unsafe-html",
                filterable: false,
            },
        );

        if (is_ip_list(kind)) {
            extraCols.properties.push(
                {
                    key: "port_status",
                    title: $format("list.columns.ports"),
                    filterable: false,
                },
                {
                    key: "os",
                    title: $format("list.columns.os"),
                    filterable: false,
                    parseAs: "unsafe-html",
                },
            );
            if (is_ip_list(kind, true).public) {
                extraCols.properties.push({
                    key: "location",
                    title: $format("list.columns.country"),
                    filterable: false,
                    parseAs: "unsafe-html",
                });
                extraCols.relations.push({
                    key: "rels",
                    title: "Hostnames",
                    filterable: false,
                    parseAs: "unsafe-html",
                });
                extraCols.relatedAssetsKind.push("hostname");
            }
            if (is_ip_list(kind, true).private) {
                extraCols.properties.push({
                    key: "netbios",
                    title: "Hostname",
                    filterable: false,
                });
            }
        }

        if (is_hostname_list(kind)) {
            extraCols.relations.push({
                key: "rels",
                title: "IPs",
                filterable: false,
                parseAs: "unsafe-html",
            });
            extraCols.relatedAssetsKind.push("public_ip", "private_ip");
        }

        if (kind.includes("domain")) {
            extraCols.properties.push(
                {
                    key: "valid_until",
                    title: $format("list.columns.valid_until"),
                    filterable: false,
                    parseAs: "unsafe-html",
                },
                {
                    key: "expiration_date",
                    title: $format("list.columns.expires_at"),
                    filterable: false,
                    parseAs: "unsafe-html",
                },
            );
        }

        if (!kind.includes("network")) {
            cols.push({
                key: "finding_count",
                title: $format("list.columns.findings"),
                parseAs: "unsafe-html",
                filterable: false,
            });
        }

        cols.push(
            {
                key: "first_discovery_at",
                title: $format("list.columns.created"),
                filterable: false,
                parseAs: "unsafe-html",
            },
            {
                key: "last_discovery_at",
                title: $format("list.columns.seen"),
                filterable: false,
                parseAs: "unsafe-html",
            },
            {
                key: "in_scope",
                title: $format("list.columns.in_scope"),
                filterable: false,
                parseAs: "unsafe-html",
            },
            {
                key: "is_dynamic",
                title: $format("list.columns.is_dynamic"),
                filterable: false,
                parseAs: "unsafe-html",
            },
            {
                key: "auto_delete",
                title: $format("list.columns.auto_delete"),
                filterable: false,
                parseAs: "unsafe-html",
            },
            {
                key: "tag",
                title: $format("list.columns.tag"),
                filterable: false,
                parseAs: "unsafe-html",
            },
        );

        if (kind === "all" || kind === "allWithActions")
            cols.push({
                key: "kind",
                title: $format("list.columns.asset_kind"),
                filterable: false,
            });

        return { columns: cols, extraColumns: extraCols };
    };

    const getColumns = (kind) => {
        if (!kind) return;
        let columnsDef = getAssetsColumnsDefinition(kind);
        ptInstructs = [
            ...columnsDef.columns,
            ...columnsDef.extraColumns.properties,
            ...columnsDef.extraColumns.relations,
        ];
        if (is_ip_list(kind)) {
            for (let [idx, value] of ptInstructs.entries()) {
                if (value.key === "name") {
                    ptInstructs[idx].userFunctions = {
                        customSort: ipAdressesCustomComparator,
                    };
                }
                if (value.key === "finding_count") {
                    ptInstructs[idx].userFunctions = {
                        customSort: powerTableService.sortFindings,
                    };
                }
                if (value.key === "port_status") {
                    ptInstructs[idx].parseAs = "component";
                    ptInstructs[idx].dataComponent = OpenPortsRow;
                    ptInstructs[idx].userFunctions = { customSort: sortPorts };
                }
                if (value.key === "location") {
                    ptInstructs[idx].userFunctions = {
                        customSort: sortCountry,
                    };
                }
                if (value.key === "os") {
                    ptInstructs[idx].userFunctions = { customSort: sortOs };
                }
            }
        }
        if (is_hostname_list(kind)) {
            for (let [idx, value] of ptInstructs.entries()) {
                if (value.key === "rels") {
                    ptInstructs[idx].userFunctions = {
                        customSort: powerTableService.ipsColCustomSort,
                    };
                    break;
                }
            }
        }

        for (let [idx, value] of ptInstructs.entries()) {
            if (
                value.key === "expiration_date" ||
                value.key === "valid_from" ||
                value.key === "valid_until"
            ) {
                ptInstructs[idx].userFunctions = { customSort: sortDates };
            }
        }
        return ptInstructs;
    };

    const showContent = (kind, id) => {
        let visibleElement = document.getElementById(kind + "-visible-" + id);
        let hiddenElement = document.getElementById(kind + "-hidden-" + id);
        visibleElement.classList.remove("is-visible");
        visibleElement.classList.add("is-hidden");
        hiddenElement.classList.remove("is-hidden");
        hiddenElement.classList.add("is-visible");
    };

    const hideContent = (kind, id) => {
        let visibleElement = document.getElementById(kind + "-visible-" + id);
        let hiddenElement = document.getElementById(kind + "-hidden-" + id);
        visibleElement.classList.add("is-visible");
        visibleElement.classList.remove("is-hidden");
        hiddenElement.classList.add("is-hidden");
        hiddenElement.classList.remove("is-visible");
    };

    const selectAll = async (e) => {
        let tData = tableElement.getData(false, ["pageData", "matchedData"]);
        let pageData = tData.pageData;
        if (!pageData || pageData.length === 0) return selected_rows;

        const selectedIds = new Set(selected_rows.map((r) => r.id));
        const allPageSelected = pageData.every((el) => selectedIds.has(el.id));
        let action = allPageSelected ? "deselect" : "select";

        if (action === "select") {
            let result;
            if (tData.matchedData.length > 10) {
                result = await notificate("select_all", "modal", {});

                if (!result.isConfirmed && result.dismiss !== "cancel") {
                    return selected_rows;
                }
            }

            let target_elements =
                result && result.isConfirmed ? tData.matchedData : pageData;
            const currentIds = new Set(selected_rows.map((x) => x.id));
            let toAdd = target_elements.filter((x) => !currentIds.has(x.id));
            selected_rows = [...selected_rows, ...toAdd];
        } else {
            selected_rows = [];
        }

        powerTableService.toggleActionButtons(selected_rows);
        const domRows = document.querySelectorAll(
            `div[data-prefix='assetTable'] table tbody tr`,
        );
        const selectedPtIds = new Set(
            selected_rows.map((r) => String(r.__PT_ID__)),
        );

        domRows.forEach((row) => {
            let rowId = row.getAttribute("data-id");
            if (selectedPtIds.has(rowId)) row.classList.add("selected");
            else row.classList.remove("selected");
        });
        return selected_rows;
    };

    const deselectAll = () => {
        selected_rows = powerTableService.deselectAll();
        powerTableService.toggleActionButtons(selected_rows);
        return selected_rows;
    };

    const selectAllEventListener = () => {
        checkbox = document.querySelector(
            "th[data-key='select'][data-sortable='false']",
        );
        if (checkbox) checkbox.addEventListener("click", selectAll);
    };

    const selectRow = (event) => {
        if (!showActions) return;
        let tData = tableElement.getData(false, ["pageData"]);
        let current = event.detail.data;
        let idx = selected_rows.findIndex((r) => r.id == current.id);
        selected_rows = powerTableService.selectRows(
            selected_rows,
            current,
            idx,
            "assetTable",
            tData.pageData,
        );
        powerTableService.toggleActionButtons(selected_rows);
        return selected_rows;
    };

    const groupRelationsByKind = (rels) => {
        let grouped = [];
        const temp = Object.entries(
            rels.reduce((acc, curr) => {
                const { relationKind } = curr;
                acc[relationKind] = acc[relationKind]
                    ? {
                          ...acc[relationKind],
                          [curr.name]: { id: curr.id, kind: curr.kind },
                      }
                    : {
                          relationKind,
                          [curr.name]: { id: curr.id, kind: curr.kind },
                      };
                return acc;
            }, {}),
        );
        Object.values(temp).forEach((val, idx) => {
            let { relationKind, ...rest } = val[1];
            grouped[idx] = { relationKind: relationKind, values: rest };
        });
        return grouped;
    };

    const getDateLabels = (date) => {
        let expiration_date;
        let expired_label;
        let now = dayjs();

        if (dayjs(date) < now) {
            let diff = dayjs(date).diff(now, "months");
            expired_label =
                $format("date_labels.from") +
                Math.abs(diff) +
                $format("date_labels.months");

            if (diff == 0) {
                diff = dayjs(date).diff(now, "days");
                expired_label =
                    $format("date_labels.from") +
                    Math.abs(diff) +
                    $format("date_labels.days");
            }
            if (diff > 12) {
                diff = dayjs(date).diff(now, "years");
                expired_label =
                    $format("date_labels.from") +
                    Math.abs(diff) +
                    $format("date_labels.years");
            }
            expiration_date = $format("expired");
        } else {
            expiration_date = dayjs(now).to(date);
        }

        return { expiration_date, expired_label };
    };

    // --- SECURE PARSER ---
    const parseRows = (pageContent) => {
        pageContent.forEach((row) => {
            let relations;
            if (row.rels)
                relations = groupRelationsByKind(JSON.parse(row.rels));

            if (row["in_scope"]) {
                row["in_scope"] =
                    row.in_scope == "true"
                        ? `<i class="fa fa-eye"></i>`
                        : '<i class="fa fa-eye-slash"></i>' +
                          (row.third_party
                              ? ` <i class="fa fa-cloud" title='Activo gestionado por ${escapeHTML(row.third_party)}'></i>`
                              : "");
            }

            row["is_dynamic"] =
                row.is_dynamic == "true"
                    ? `<i title="${$format("asset.is_dynamic")}" class="fas fa-cogs"></i>`
                    : `<i title="${$format("asset.is_not_dynamic")}" class="fas fa-user"></i>`;

            row["auto_delete"] =
                row.auto_delete == "true"
                    ? $format("asset.auto_delete")
                    : $format("asset.manual_delete");

            if (row["finding_count"])
                row["finding_count"] =
                    powerTableService.parseFindingCountRow(row);

            if (row.port_status)
                row["port_status"] = {
                    port_status: JSON.parse(row.port_status),
                };

            if (row["location"]) {
                let locationObj = JSON.parse(row.location);
                let location = escapeHTML(
                    locationObj.vals.country_code.toLowerCase(),
                );
                let countryCode = escapeHTML(locationObj.vals.country_code);
                row["location"] =
                    `<a href="/property/asset/location/country_code/values?value=${countryCode}"><i class="flag-icon flag-icon-${location}"></i></a>`;
            } else {
                row["location"] = assets.list.loading
                    ? `<div><i class="fas fa-sync-alt fa-spin"></i></div>`
                    : "";
            }

            row.tag = row.tag
                ? powerTableService.parseTagsRow(row.tag, row.__PT_ID__)
                : assets.list.loading
                  ? `<div><i class="fas fa-sync-alt fa-spin"></i></div>`
                  : "";

            row.rels =
                row.rels && relations
                    ? powerTableService.parseRelationsRow(
                          relations,
                          row.__PT_ID__,
                          row.kind,
                      )
                    : assets.list.loading
                      ? `<div><i class="fas fa-sync-alt fa-spin"></i></div>`
                      : "";

            if (row["first_discovery_at"]) {
                row["first_discovery_at"] =
                    `<span title="${escapeHTML(row.first_discovery_at)}">${escapeHTML(dateText(row["first_discovery_at"]))}</span>`;
            }
            if (row["last_discovery_at"]) {
                row["last_discovery_at"] =
                    `<span title="${escapeHTML(row.last_discovery_at)}">${escapeHTML(dateText(row["last_discovery_at"]))}</span>`;
            }
            if (row["valid_from"]) {
                row["valid_from"] =
                    `<span title="${escapeHTML(row.valid_from)}">${escapeHTML(dayjs(row["valid_from"]).format("YYYY-MM-DD"))}</span>`;
            } else {
                row.valid_from = assets.list.loading
                    ? `<div><i class="fas fa-sync-alt fa-spin"></i></div>`
                    : "";
            }
            if (row["valid_until"]) {
                row["valid_until"] =
                    `<span title="${escapeHTML(row.valid_until)}">${escapeHTML(dayjs(row["valid_until"]).format("YYYY-MM-DD"))}</span>`;
            } else {
                row.valid_until = assets.list.loading
                    ? `<div><i class="fas fa-sync-alt fa-spin"></i></div>`
                    : "";
            }
            if (row["expiration_date"]) {
                let date = escapeHTML(
                    getDateLabels(row["expiration_date"]).expiration_date,
                );
                let expRaw = escapeHTML(row.expiration_date);
                row["expiration_date"] =
                    date === escapeHTML($format("expired"))
                        ? `<span title="${expRaw}" class="vlsk-red">${date}</span>`
                        : `<span title="${expRaw}">${date}</span>`;
            } else {
                row.expiration_date = assets.list.loading
                    ? `<div><i class="fas fa-sync-alt fa-spin"></i></div>`
                    : "";
            }

            if (row["name"]) {
                row["name"] =
                    `<a href='/asset/${escapeHTML(row.kind)}/${escapeHTML(row["id"])}' title="Ver">${escapeHTML(row.name)}</a>`;
            }
            if (row["kind"]) {
                row["kind"] = $format(`asset.kind.${row.kind}.singular`);
            }
            if (row["os"]) {
                let original_value = escapeHTML(row.os);
                let icon = AssetsApi.os_icons.find((icon) =>
                    row.os
                        .toLowerCase()
                        .replaceAll(" ", "")
                        .includes(icon.label),
                );
                if (icon) {
                    row.os = `<a href="/property/asset/os/name/values?value=${encodeURIComponent(row.os)}"><img title="${original_value}" src="/img/${escapeHTML(icon.fileName)}" style="height: ${icon.height}px;" /></a>`;
                } else {
                    row.os = `<a href="/property/asset/os/name/values?value=${encodeURIComponent(row.os)}"><i title="${original_value}" class='fas fa-tools'></i></a>`;
                }
            }
        });
        deselectAll();
        return pageContent;
    };

    let ptOptions = $state({
        uniquePrefix: "assetTable",
        rowsPerPageOptions: [10, 20, 50, 100],
        footerText: false,
        footerFilters: false,
        footerLoadingBar: false,
        segments: {
            pTable: ["table"],
            bottomBar: ["dropdown", "stats", "pagination"],
        },
        translations: {
            add: $format("list.interface.add"),
            delete: $format("list.interface.delete"),
            filterBy: $format("list.interface.filterBy"),
            from: $format("list.interface.from"),
            invertSelection: $format("list.interface.invertSelection"),
            next: $format("list.interface.next"),
            of: $format("list.interface.of"),
            previous: $format("list.interface.previous"),
            rows: $format("list.interface.rows"),
            search: $format("list.interface.search"),
            selectAll: $format("list.interface.selectAll"),
            selectNone: $format("list.interface.selectNone"),
        },
        isDataRemote: false,
        userFunctions: { customParse: parseRows },
    });

    /* END LIST FUNCTIONS */

    /* START EXPORT FUNCTIONS */

    const exportToJSON = (e) => {
        let fileName = !kind.includes("all") ? kind : "Assets";
        let currentData = JSON.parse(
            JSON.stringify(
                tableElement.getData(false, "matchedData").matchedData,
            ),
        );
        for (let item of currentData) {
            delete item.__PT_ID__;
            delete item.__PT_CB__;
            for (let [k, v] of Object.entries(item)) {
                if (typeof v === "string" && isJson(item[k])) {
                    item[k] = JSON.parse(v);
                }
                if (k === "rels") {
                    if (kind == "public_ip") item["Hostnames"] = item[k];
                    if (is_hostname_list(kind)) item["IPs"] = item[k];
                    delete item[k];
                }
                if (k === "port_status") {
                    if (item[k].length > 0) {
                        let entries = [];
                        for (let [key, value] of Object.entries(
                            item[k][0].vals,
                        ))
                            entries.push([key, value]);
                        for (let [index, entry] of Object.entries(
                            AssetsApi.sortGroupedPorts(entries),
                        )) {
                            entries[index] = entry[0] + ": " + entry[1];
                        }
                        item[k] = entries;
                    }
                }
                if (k === "location") {
                    item[k] = item[k].vals ? item[k].vals.country_code : "";
                }
            }
        }
        let dataStr =
            "data:text/json;charset=utf-8," +
            encodeURIComponent(JSON.stringify(currentData));
        let downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", `${fileName}_vulseek.json`);
        document.body.appendChild(downloadAnchorNode);
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    };

    const exportToCSV = async () => {
        let fileName = !kind.includes("all") ? kind : "Assets";
        let header = [];
        let titles = [];
        let relations = kind == "public_ip" ? "Hostnames" : "IPs";
        const data = tableElement.getData(false, "matchedData").matchedData;
        let items = JSON.parse(JSON.stringify(data));

        for (let item of items) {
            if (isJson(item.finding_count)) {
                let totals_by_status = JSON.parse(item.finding_count);
                item.finding_count =
                    `${$format("export.critical")}: ` +
                    (totals_by_status.critical.open +
                        totals_by_status.critical.accepted) +
                    ` | ${$format("export.high")}: ` +
                    (totals_by_status.high.open +
                        totals_by_status.high.accepted) +
                    ` | ${$format("export.medium")}: ` +
                    (totals_by_status.medium.open +
                        totals_by_status.medium.accepted) +
                    ` | ${$format("export.low")}: ` +
                    (totals_by_status.low.open + totals_by_status.low.accepted);
            }
            let tags = isJson(item.tag) ? JSON.parse(item.tag) : [];
            item.tag = tags.map((t) => t.name).join(", ");
            item.in_scope =
                item.in_scope === "true" ? $format("yes") : $format("no");

            if (kind == "public_ip" || kind == "hostname") {
                let rels = JSON.parse(item.rels);
                item[relations] = rels
                    .map((r) => r.nickname || r.name)
                    .join(", ");
            }
            if (kind == "public_ip") {
                item.location =
                    item.location === ""
                        ? item.location
                        : countries.names[
                              JSON.parse(item.location).vals.country_code
                          ];
            }
            if (is_ip_list(kind, false)) {
                let ports = JSON.parse(item.port_status);
                let portNames = [];
                for (let port of ports)
                    portNames.push(...Object.keys(port.vals));
                item.port_status = portNames.join(", ");
            }
            delete item.props;
            delete item.rels;
        }

        // SECURITY: Block CSV Injection (Excel formula execution payload)
        const replacer = (key, value) => {
            if (value === null) return "";
            if (typeof value === "string" && /^[=+\-@]/.test(value)) {
                return "'" + value;
            }
            return value;
        };

        ptInstructs.forEach((col) => {
            if (col.key != "select") {
                header.push({ key: col.key, value: col.title });
                let t = col.title.includes(" ")
                    ? col.title.replace(" ", "_")
                    : col.title;
                titles.push(t == "En alcance" ? "Alcance" : t);
            }
        });

        if (is_ip_list(kind, true).public || is_hostname_list(kind)) {
            header.push({ key: relations, value: relations });
            titles.push(relations);
        }

        const csv = [
            titles.join(";"),
            ...items.map((row) =>
                header
                    .map((fieldName) =>
                        JSON.stringify(row[fieldName["key"]], replacer),
                    )
                    .join(";"),
            ),
        ].join("\r\n");

        let hiddenElement = document.createElement("a");
        hiddenElement.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        hiddenElement.target = "_blank";
        hiddenElement.download = `${fileName}_vulseek.csv`;
        hiddenElement.click();
    };

    const copyToClipboard = async () => {
        try {
            // Generate CSV data using the same logic as exportToCSV
            let header = [];
            let titles = [];
            let relations = kind == "public_ip" ? "Hostnames" : "IPs";
            const data = tableElement.getData(false, "matchedData").matchedData;
            let items = JSON.parse(JSON.stringify(data));

            for (let item of items) {
                if (isJson(item.finding_count)) {
                    let totals_by_status = JSON.parse(item.finding_count);
                    item.finding_count =
                        `${$format("export.critical")}: ` +
                        (totals_by_status.critical.open +
                            totals_by_status.critical.accepted) +
                        ` | ${$format("export.high")}: ` +
                        (totals_by_status.high.open +
                            totals_by_status.high.accepted) +
                        ` | ${$format("export.medium")}: ` +
                        (totals_by_status.medium.open +
                            totals_by_status.medium.accepted) +
                        ` | ${$format("export.low")}: ` +
                        (totals_by_status.low.open +
                            totals_by_status.low.accepted);
                }
                let tags = isJson(item.tag) ? JSON.parse(item.tag) : [];
                item.tag = tags.map((t) => t.name).join(", ");
                item.in_scope =
                    item.in_scope === "true" ? $format("yes") : $format("no");
                item.auto_delete =
                    item.auto_delete === "true"
                        ? $format("Automatico")
                        : $format("Manual");
                item.is_dynamic =
                    item.is_dynamic === "true"
                        ? $format("Vulseek")
                        : $format("Manual");

                if (kind == "public_ip" || kind == "hostname") {
                    let rels = JSON.parse(item.rels);
                    item[relations] = rels
                        .map((r) => r.nickname || r.name)
                        .join(", ");
                }
                if (kind == "public_ip") {
                    item.location =
                        item.location === ""
                            ? item.location
                            : countries.names[
                                  JSON.parse(item.location).vals.country_code
                              ];
                }
                if (is_ip_list(kind, false)) {
                    let ports = JSON.parse(item.port_status);
                    let portNames = [];
                    for (let port of ports)
                        portNames.push(...Object.keys(port.vals));
                    item.port_status = portNames.join(", ");
                }
                delete item.props;
                delete item.rels;
            }

            // SECURITY: Block CSV Injection (Excel formula execution payload)
            const replacer = (key, value) => {
                if (value === null) return "";
                if (typeof value === "string" && /^[=+\-@]/.test(value)) {
                    return "'" + value;
                }
                return value;
            };

            ptInstructs.forEach((col) => {
                if (col.key != "select") {
                    header.push({ key: col.key, value: col.title });
                    let t = col.title.includes(" ")
                        ? col.title.replace(" ", "_")
                        : col.title;
                    titles.push(t == "En alcance" ? "Alcance" : t);
                }
            });

            if (is_ip_list(kind, true).public || is_hostname_list(kind)) {
                header.push({ key: relations, value: relations });
                titles.push(relations);
            }

            const csv = [
                titles.join(";"),
                ...items.map((row) =>
                    header
                        .map((fieldName) =>
                            JSON.stringify(row[fieldName["key"]], replacer),
                        )
                        .join(";"),
                ),
            ].join("\r\n");

            // Copy to clipboard using modern Clipboard API
            await navigator.clipboard.writeText(csv);

            notificate("copied", "toast", {
                data: $format("copied"),
            });
        } catch (err) {
            // Show error notification
            notificate("save_error", "toast", {
                data: $format("buttons.copy_to_clipboard_failed"),
            });
        }
    };

    /* END EXPORT FUNCTIONS */

    /* START SORTING FUNCTIONS */

    function sortDates(a, b) {
        if (a === "") a = null;
        if (b === "") b = null;
        if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
            if (!a && a !== 0 && a !== false && !b && b !== 0 && b !== false)
                return 0;
            if (!a && a !== 0 && a !== false) return -1;
            if (!b && b !== 0 && b !== false) return 1;
        }
        if (!(a instanceof Date)) a = new Date(a);
        if (!(b instanceof Date)) b = new Date(b);
        return a.getTime() === b.getTime()
            ? 0
            : a.getTime() < b.getTime()
              ? -1
              : 1;
    }

    const sortPorts = (v1, v2) => {
        if (v1 === "" || v2 === "") return;
        let v1_ports_ordered = AssetsApi.sortGroupedPorts(
            Object.entries(JSON.parse(v1)[0]?.vals || {}),
        );
        let v2_ports_ordered = AssetsApi.sortGroupedPorts(
            Object.entries(JSON.parse(v2)[0]?.vals || {}),
        );

        let port1_splited = v1_ports_ordered[0]
            ? v1_ports_ordered[0][0].split("/")
            : [];
        let port2_splited = v2_ports_ordered[0]
            ? v2_ports_ordered[0][0].split("/")
            : [];

        let protocol_1 = port1_splited[0] || "";
        let num_1 = parseInt(port1_splited[1] || 0);
        let protocol_2 = port2_splited[0] || "";
        let num_2 = parseInt(port2_splited[1] || 0);

        return protocol_1.localeCompare(protocol_2) == 0
            ? num_1 > num_2
                ? 1
                : -1
            : protocol_1.localeCompare(protocol_2);
    };

    const sortCountry = (v1, v2) => {
        v1 = v1 != "" ? JSON.parse(v1) : { vals: { country_code: "" } };
        v2 = v2 != "" ? JSON.parse(v2) : { vals: { country_code: "" } };
        return v1.vals.country_code.localeCompare(v2.vals.country_code);
    };

    const sortOs = (v1, v2) => {
        let icon1 = AssetsApi.os_icons.find((icon) =>
            v1.toLowerCase().replaceAll(" ", "").includes(icon.label),
        );
        let icon2 = AssetsApi.os_icons.find((icon) =>
            v2.toLowerCase().replaceAll(" ", "").includes(icon.label),
        );
        return (icon1 ? icon1.label : "").localeCompare(
            icon2 ? icon2.label : "",
        );
    };

    /* END SORTING FUNCTIONS */

    // --- MODAL TRIGGERS ---
    const openAddModal = (e) => {
        if (e) e.preventDefault();
        addFormKey++; // Trashes form state
        addModalInstance.show();
    };

    const handleEdit = async (selected_rows) => {
        if (selected_rows.length < 1)
            return notificate("select_element", "modal");
        editFormKey++; // Trashes form state
        editModalInstance.show();
    };

    function handleCloseModal(e) {
        if (e && e.preventDefault) e.preventDefault();
        addModalInstance.hide();
    }

    const closeEditModal = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        editModalInstance.hide();
    };

    const openTagModal = () => jQuery("#tag-add-modal").modal("show");

    const closeTagModal = () => {
        jQuery("#tag-add-modal").modal("hide");
        let element = document.getElementById("tagsSelect");
        if (element) element.selectedIndex = 0;
    };

    const openTagRemoveModal = () => jQuery("#tag-remove-modal").modal("show");

    const closeRemoveTagModal = async () => {
        jQuery("#tag-remove-modal").modal("hide");
        document.getElementById("tagsSelect").selectedIndex = 0;
        let newData = await hydrateAssetsWithTags(listData);
        assets.list.data = newData;
    };

    const handleAddTag = (event) => {
        handleTagEditFn({ target: { value: event.detail.savedTag.id } });
    };

    const handleTagEditFn = async (element) => {
        let value = element.target.value;
        let requestData = [];

        if (value == "cancel") return;
        if (value == "removeTags") {
            if (selected_rows.length > 1)
                return notificate("select_only_one", "modal");
            return openTagRemoveModal();
        }
        if (value == "addNewTag") {
            if (selected_rows.length <= 0)
                return notificate("select_element", "modal");
            return openTagModal();
        }

        let asset_ids = new Set(selected_rows.map((node) => node.id));
        let assetsToEdit = listData.filter((asset) => asset_ids.has(asset.id));

        if (assetsToEdit.length === 0)
            return notificate("select_element", "modal");

        for (let asset of assetsToEdit) {
            requestData.push({
                tag_id: value,
                target_object_type: "Asset",
                target_object_id: asset.id,
            });
        }

        let response = await MassiveActionsService.handleTagAssociation(
            requestData,
            {},
        );
        if (response.errors.length === 0) {
            notificate("save_ok", "toast", {
                data: $format("asset.plural"),
                is_massive: true,
            });
            let newData = await hydrateAssetsWithTags(listData);
            replaceAssetsListElements(newData);
        } else {
            let failed_assets_ids = response.errors.map(
                (error) => error.target_object_id,
            );
            let failed = assetsToEdit.filter((asset) =>
                failed_assets_ids.includes(asset.id),
            );
            assets.list.data = await hydrateAssetsWithTags(listData);

            for (let fail of failed) {
                notificate("save_error", "toast", {
                    data: fail.name,
                    options: {
                        timeOut: "0",
                        extendedTimeOut: "0",
                        showDuration: "0",
                        hideDuration: "0",
                        closeButton: true,
                    },
                });
            }
        }
        closeTagModal();
        selected_rows = [];
    };

    const handleKeydown = (event) => {
        let page = tableElement.getData().options.currentPage;
        if (event.keyCode == 39) ptOptions.currentPage = page + 1;
        if (event.keyCode == 37 && page - 1 > 0)
            ptOptions.currentPage = page - 1;
    };

    const customSearch = (searchInput) => {
        if (!searchInput) return;
        let result = JSON.parse(
            JSON.stringify($state.snapshot(assets.list.data)),
        );

        if (searchInput.length < 1) return (assets.list.data = result);

        let input = normalizeString(searchInput);

        function searchListValue(list, input, col) {
            if (col === "port") {
                let ports = "";
                for (let port of list)
                    ports += " " + Object.keys(port.vals).join(" ");
                return ports.includes(input);
            }
            return list
                .map((item) => item.name)
                .join(" ")
                .includes(input);
        }

        result = result.filter((item) => {
            if (item.name && normalizeString(item.name).includes(input))
                return true;
            if (
                item.description &&
                normalizeString(item.description).includes(input)
            )
                return true;
            if (item.tag && searchListValue(item.tag, input, "tag"))
                return true;
            if (item.rels && searchListValue(item.rels, input, "rels"))
                return true;
            if (
                item.port_status &&
                searchListValue(item.port_status, input, "port")
            )
                return true;
            if (
                item.location &&
                normalizeString(
                    countries.names[item.location.vals.country_code] || "",
                ).includes(input)
            )
                return true;
            if (
                item.valid_from &&
                dayjs(item.valid_from).format("YYYY-MM-DD").includes(input)
            )
                return true;
            if (
                item.valid_until &&
                dayjs(item.valid_until).format("YYYY-MM-DD").includes(input)
            )
                return true;
            if (
                item.expiration_date &&
                getDateLabels(item.expiration_date).expiration_date.includes(
                    input,
                )
            )
                return true;
            if (item.netbios && normalizeString(item.netbios).includes(input))
                return true;
            return false;
        });
        return result;
    };

    const hideRows = () => {
        listData =
            searchInput == ""
                ? data.filter((elem) => elem.in_scope)
                : customSearch(searchInput);
        let stats_container = document.querySelectorAll(
            '[data-name="stats-container"]',
        )[0];
        if (
            !stats_container.textContent.includes(
                $format("list.interface.hidden_results"),
            )
        ) {
            let element = document.createElement("span");
            element.setAttribute("id", "outOfScopeResults");
            element.appendChild(
                document.createTextNode(
                    "(" +
                        out_of_scope_length +
                        $format("list.interface.hidden_results") +
                        ")",
                ),
            );
            stats_container.appendChild(element);
        }
        table_is_expanded = false;
    };

    const showRows = async () => {
        listData = searchInput == "" ? data : customSearch(searchInput);
        await tick();
        document.getElementById("outOfScopeResults")?.remove();
        table_is_expanded = true;
    };

    $effect(() => {
        out_of_scope_length > 0 ? hideRows() : showRows();
    });

    const handleRefresh = async () => {
        const currentFilters = JSON.parse(JSON.stringify($params || {}));

        let filterConfig = {
            ...currentFilters,
            include_finding_count: true,
        };

        if (kind && kind !== "all" && kind !== "allWithActions") {
            filterConfig.kind = kind;
        }

        await searchAssets("v2/asset/", {
            filter: filterConfig,
            buildList: {
                properties: true,
                tags: { elements: tags, associations: associations },
            },
        });
    };

    onMount(async () => {
        addModalInstance = new bootstrap.Modal(addModalElement);
        editModalInstance = new bootstrap.Modal(editModalElement);
        getColumns(kind);
        await tick();
        selectAllEventListener();
    });

    onDestroy(() => {
        if (checkbox) checkbox.removeEventListener("click", selectAll);
    });

    window.showContent = showContent;
    window.hideContent = hideContent;
</script>

<svelte:window onkeydown={handleKeydown} />

<div class="card mt-3">
    <div class="card-header">
        <div class="float-start">
            {#if ptInstructs.length > 0}
                <TableReference
                    columnsDefinition={ptInstructs}
                    list={"asset"}
                />
            {/if}
        </div>
        {#if showActions}
            <div class="float-end">
                {#if kind && kind != "all"}
                    {#if kind != "email" && kind != "container_image" && user.data.role != "viewer"}
                        <button
                            class="btn btn-secondary table-button btn-add btn-xs t-add-asset-btn"
                            aria-label="addAsset"
                            tabindex="0"
                            aria-controls="assetTable"
                            type="button"
                            title={$format("buttons.add")}
                            id="assetAddBtn"
                            onclick={openAddModal}
                            ><i class="fa fa-plus"></i></button
                        >
                    {/if}
                    {#if user.data.role != "viewer"}
                        <button
                            disabled
                            class="btn btn-secondary btn-disabled table-button btn-delete btn-xs t-delete-asset-btn"
                            tabindex="0"
                            aria-controls="assetTable"
                            type="button"
                            title={$format("buttons.delete")}
                            id="assetDeleteBtn"
                            aria-label="deleteAssets"
                            onclick={() => handleAssetsDelete(selected_rows)}
                            ><i class="fa fa-trash"></i></button
                        >
                        <button
                            disabled
                            class="btn btn-secondary btn-disabled table-button btn-edit btn-xs t-edit-asset-btn"
                            tabindex="0"
                            aria-controls="assetTable"
                            type="button"
                            title={$format("buttons.edit")}
                            id="asset-edit-btn"
                            aria-label="editAssets"
                            onclick={() => handleEdit(selected_rows)}
                            ><i class="fa fa-edit"></i></button
                        >
                        <button
                            disabled
                            class="btn btn-secondary btn-disabled table-button btn-add-scope btn-xs t-button-add-scope"
                            tabindex="0"
                            aria-controls="assetTable"
                            type="button"
                            title={$format("buttons.add_scope")}
                            id="assetScopeAddBtn"
                            aria-label="addToScope"
                            onclick={() =>
                                handleScopeChange(selected_rows, true)}
                            ><i class="fas fa-eye"></i></button
                        >
                        <button
                            disabled
                            class="btn btn-secondary btn-disabled table-button btn-add-scope btn-xs t-button-add-scope"
                            tabindex="0"
                            aria-controls="assetTable"
                            type="button"
                            title={$format("buttons.remove_scope")}
                            id="assetScopeRemoveBtn"
                            aria-label="removeFromScope"
                            onclick={() =>
                                handleScopeChange(selected_rows, false)}
                            ><i class="fas fa-eye-slash"></i></button
                        >
                    {/if}
                    {#if show_expand_button && out_of_scope_length > 0}
                        {#if table_is_expanded}
                            <button
                                class="btn btn-secondary table-button btn-compress btn-xs t-compress-asset-btn"
                                disabled={searchInput != ""}
                                aria-label="shrinkTable"
                                tabindex="0"
                                aria-controls="vulnerabilityTable"
                                type="button"
                                title={$format("buttons.hide_out_of_scope")}
                                id="assetCompressBtn"
                                onclick={hideRows}
                                ><i class="fas fa-compress-arrows-alt"
                                ></i></button
                            >
                        {:else}
                            <button
                                class="btn btn-secondary table-button btn-expand btn-xs t-expand-asset-btn"
                                disabled={searchInput != ""}
                                aria-label="expandTable"
                                tabindex="0"
                                aria-controls="assetTable"
                                type="button"
                                title={$format("buttons.show_out_of_scope")}
                                id="assetExpandBtn"
                                onclick={showRows}
                                ><i class="fas fa-expand-arrows-alt"
                                ></i></button
                            >
                        {/if}
                    {/if}
                    <button
                        class="btn btn-secondary table-button btn-refresh btn-xs t-refresh-asset-btn"
                        aria-label="refresh"
                        tabindex="0"
                        aria-controls="assetTable"
                        type="button"
                        title={$format("buttons.refresh")}
                        id="assetRefreshBtn"
                        onclick={() => handleRefresh()}
                        ><i class="fa fa-sync-alt"></i></button
                    >
                    <button
                        class="btn btn-secondary table-button btn-export btn-xs t-json-asset-btn"
                        aria-label="export to JSON"
                        tabindex="0"
                        aria-controls="assetTable"
                        type="button"
                        title={$format("buttons.json")}
                        id="assetJSONbtn"
                        onclick={exportToJSON}
                        ><i class="fab fa-js-square" style="font-size: 18px;"
                        ></i></button
                    >
                    <button
                        class="btn btn-secondary table-button btn-export btn-xs t-csv-asset-btn"
                        aria-label="export to CSV"
                        tabindex="0"
                        aria-controls="assetTable"
                        type="button"
                        title={$format("buttons.csv")}
                        id="assetCSVbtn"
                        onclick={exportToCSV}
                        ><i class="fa fa-file-csv" style="font-size: 18px;"
                        ></i></button
                    >
                    <button
                        class="btn btn-secondary table-button btn-export btn-xs t-copy-asset-btn"
                        aria-label="copy to clipboard"
                        tabindex="0"
                        aria-controls="assetTable"
                        type="button"
                        title={$format("buttons.copy_to_clipboard")}
                        id="assetCopyBtn"
                        onclick={copyToClipboard}
                        ><i class="fa fa-copy" style="font-size: 18px;"
                        ></i></button
                    >
                    <div class="float-end d-flex">
                        {#if kind != "domain" && !kind.includes("network")}
                            <select
                                disabled
                                id="autodeleteSelect"
                                name="autodeleteSelect"
                                class="form-control btn-disabled"
                                style="height: 28px; clear: left;  max-width: 125px;font-size: 12px; margin-right: 10px;"
                                oninput={(e) =>
                                    handleAutoDeleteChange(
                                        selected_rows,
                                        e.target.value,
                                    )}
                            >
                                <option value="cancel"
                                    >{$format("buttons.auto_delete")}</option
                                >
                                <option disabled>----------</option>
                                <option value={true}
                                    >{$format("asset.auto_delete")}</option
                                >
                                <option value={false}
                                    >{$format("asset.manual_delete")}</option
                                >
                            </select>
                        {/if}
                        {#if user.data.role != "viewer"}
                            <select
                                disabled
                                id="tagsSelect"
                                name="tagsSelect"
                                class="form-control btn-disabled"
                                style="height: 28px; clear: left;  max-width: 125px;font-size: 12px; margin-right: 10px;"
                                oninput={(e) => handleTagEditFn(e)}
                            >
                                <option value="cancel"
                                    >{$format(
                                        "buttons.select_tag.select",
                                    )}</option
                                >
                                <option disabled>----------</option>
                                <option value="addNewTag"
                                    >{$format(
                                        "buttons.select_tag.add_and_associate",
                                    )}</option
                                >
                                <option disabled>----------</option>
                                <option value="removeTags"
                                    >{$format(
                                        "buttons.select_tag.remove",
                                    )}</option
                                >
                                <option disabled>----------</option>
                                {#each [...tags].sort( (a, b) => a.name.localeCompare(b.name), ) as tag (tag.id)}
                                    <option value={tag.id}>{tag.name}</option>
                                {/each}
                            </select>
                        {/if}
                    </div>
                {/if}
            </div>
        {:else}
            <span>{$format("asset.plural")}</span>
            <div class="float-end">
                <button
                    class="btn btn-secondary table-button btn-export btn-xs t-json-asset-btn"
                    tabindex="0"
                    aria-controls="assetTable"
                    type="button"
                    title={$format("buttons.json")}
                    id="assetJSONbtn"
                    onclick={exportToJSON}
                    ><i class="fab fa-js-square" style="font-size: 18px;"
                    ></i></button
                >
                <button
                    class="btn btn-secondary table-button btn-export btn-xs t-csv-asset-btn"
                    tabindex="0"
                    aria-controls="assetTable"
                    type="button"
                    title={$format("buttons.csv")}
                    id="assetCSVbtn"
                    onclick={exportToCSV}
                    ><i class="fa fa-file-csv" style="font-size: 18px;"
                    ></i></button
                >
            </div>
        {/if}
    </div>
    <div class="card-body">
        <div class="table-responsive">
            <form
                class="form-inline"
                novalidate
                onsubmit={(e) => e.preventDefault()}
            >
                <div class="input-group input-group-sm">
                    <input
                        class="form-control custom-search"
                        placeholder={$format("filter")}
                        data-name="search-input"
                        type="text"
                        bind:value={searchInput}
                    />
                    <div class="input-group-append">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </form>
            <PowerTable
                ptData={listData}
                {ptInstructs}
                {ptOptions}
                on:rowClicked={(e) => selectRow(e)}
                bind:this={tableElement}
            >
                {#snippet noResults()}
                    <div>
                        {#if assets.errors}{JSON.stringify(
                                assets.errors,
                            )}{:else}{$format("results_not_found")}{/if}
                        {#if out_of_scope_length > 0}{@html $format(
                                "list.interface.hidden_results_text",
                            )}{/if}
                    </div>
                {/snippet}
            </PowerTable>
        </div>
    </div>
</div>

<!-- ADD MODAL -->
<div
    class="modal fade"
    id="asset-add-modal"
    tabindex="-1"
    aria-hidden="true"
    bind:this={addModalElement}
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {$format("add")}
                    {$format("asset.word")}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    onclick={handleCloseModal}
                    aria-label="Close"
                ></button>
            </div>
            <div class="modal-body">
                {#key addFormKey}
                    {#if kind}
                        {#if !ShowMassiveAdditionForm}
                            <Form
                                kind={kind != "all" && kind != "allWithActions"
                                    ? kind
                                    : null}
                                {handleCloseModal}
                            />
                        {:else}
                            <MassiveAddForm
                                kind={kind != "all" && kind != "allWithActions"
                                    ? kind
                                    : null}
                                {handleCloseModal}
                            />
                        {/if}
                        <a
                            class="float-end"
                            href="#"
                            onclick={(e) => {
                                e.preventDefault();
                                ShowMassiveAdditionForm =
                                    !ShowMassiveAdditionForm;
                            }}
                        >
                            {#if !ShowMassiveAdditionForm}{$format(
                                    "page.asset.form.fields.enable",
                                )}{:else}{$format(
                                    "page.asset.form.fields.disable",
                                )}{/if}
                            {$format("page.asset.form.fields.massive_upload")}
                        </a>
                    {/if}
                {/key}
            </div>
        </div>
    </div>
</div>

<!-- EDIT MODAL -->
<div
    class="modal fade"
    id="asset-edit-modal"
    tabindex="-1"
    aria-hidden="true"
    bind:this={editModalElement}
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {$format("buttons.edit")}
                    {$format("asset.plural")}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    onclick={closeEditModal}
                    aria-label="Close"
                ></button>
            </div>
            <div class="modal-body">
                {#key editFormKey}
                    <MassiveEditForm {selected_rows} {closeEditModal} />
                {/key}
            </div>
        </div>
    </div>
</div>

<!-- TAG ADD MODAL (Assuming keeping jQuery here since it belongs to a different component/workflow, but you can upgrade this too later!) -->
<div
    class="modal fade show"
    id="tag-add-modal"
    style="display: none; padding-right: 9px;"
    aria-modal="true"
    role="dialog"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("page.tag.add")}</h4>
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"><span aria-hidden="true">×</span></button
                >
            </div>
            <div class="modal-body">
                <TagForm
                    on:save={handleAddTag}
                    on:closeModal={closeTagModal}
                    tag={null}
                />
            </div>
        </div>
    </div>
</div>

<!-- TAG REMOVE MODAL -->
<div
    class="modal fade show"
    id="tag-remove-modal"
    style="display: none; padding-right: 9px;"
    aria-modal="true"
    role="dialog"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("page.tag.remove")}</h4>
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"><span aria-hidden="true">×</span></button
                >
            </div>
            <div class="modal-body">
                {#key selected_rows}
                    {#if selected_rows.length > 0}
                        <RemoveAssetTag
                            asset={selected_rows[0]}
                            on:closeModal={closeRemoveTagModal}
                            on:removeTags={closeRemoveTagModal}
                        />
                    {/if}
                {/key}
            </div>
        </div>
    </div>
</div>

<style>
    .custom-search {
        background-color: whitesmoke;
        border-color: #e8e8e8;
        color: rgba(52, 58, 64, 0.8);
    }
    .input-group {
        width: 25%;
        position: relative;
    }
    .input-group-append {
        position: absolute;
        right: 25px;
        top: 5px;
        z-index: 99999;
    }
    .input-group-append .fas.fa-search {
        color: rgba(52, 58, 64, 0.8);
    }
</style>
